import { useLocation, useNavigate } from "react-router-dom";
import { ALL_TABS, SIDEBAR } from "../data/sidebarConfig";
import { Search, Bell, ChevronRight } from "lucide-react";
import AccountSwitcher from "./AccountSwitcher";

export default function Topbar() {
  const { pathname } = useLocation();
  const nav = useNavigate();

  // Routes hors sidebarConfig — breadcrumb spécial
  const EXTRA = {
    "/settings": { label: "Paramètres", section: "Compte" },
  };

  const extra = EXTRA[pathname];
  const exact = !extra ? ALL_TABS.find(t => t.path === pathname) : null;
  const prefix = !exact && !extra ? ALL_TABS.find(t => t.path !== "/" && pathname.startsWith(t.path)) : null;
  const current = extra ? { label: extra.label, id: "extra" } : (exact || prefix || ALL_TABS[0]);
  const section = extra ? { label: extra.section } : SIDEBAR.find(s => s.items.some(i => i.id === current.id));

  return (
    <header
      className="sticky top-0 z-30 backdrop-blur-xl"
      style={{ background: "color-mix(in srgb, var(--bg-base) 80%, transparent)", borderBottom: "1px solid var(--border-default)" }}
      data-testid="topbar"
    >
      <div className="px-8 py-3.5 flex items-center justify-between gap-4">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm min-w-0">
          {section && (
            <>
              <span className="hidden md:inline font-medium" style={{ color: "var(--text-muted)" }}>{section.label}</span>
              <ChevronRight className="hidden md:inline w-3.5 h-3.5" style={{ color: "var(--text-muted)" }} />
            </>
          )}
          <h1 className="font-display font-semibold tracking-tight truncate" style={{ color: "var(--text-primary)", fontSize: 16 }} data-testid="topbar-title">
            {current.label}
          </h1>
        </div>

        {/* Center search */}
        <div className="hidden md:flex flex-1 max-w-md mx-4">
          <div className="relative w-full">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: "var(--text-muted)" }} strokeWidth={1.5} />
            <input
              type="text"
              placeholder="Rechercher (⌘K)..."
              onFocus={() => { /* TODO: open global search */ }}
              className="w-full pl-10 pr-3 py-2 rounded-lg text-sm outline-none transition"
              style={{
                background: "var(--bg-surface)",
                color: "var(--text-primary)",
                border: "1px solid var(--border-default)",
              }}
              data-testid="global-search"
            />
          </div>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-2 shrink-0">
          <AccountSwitcher />
          <button
            onClick={() => nav("/alerts")}
            data-testid="notifications-btn"
            className="relative p-2 rounded-lg transition"
            style={{ color: "var(--text-secondary)" }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = "var(--bg-surface-hover)"}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}
          >
            <Bell className="w-4.5 h-4.5" strokeWidth={1.6} />
          </button>
        </div>
      </div>
    </header>
  );
}
